<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
    >
        <color-widget
                :name="name"
                :value="value"
                :colors="colors"
                :error="error"
                @input="$emit('input', $event)"
        ></color-widget>
    </form-group>
</template>

<script>
    import ColorWidget from "@/components/FormGroups/Widgets/Color"
    import FormGroup from "@/vendor/forms/FormGroups/Horizontal/FormGroup"

    export default {
        components: {ColorWidget, FormGroup},

        props: {
            "name": {},
            "label": {},
            "helpText": {"default": null},
            "value": {},
            "error": {},
            "labelWidth": {},
            "inputWidth": {},
            "colors": {}
        },
    }
</script>
